import React, { useState, useEffect } from "react";

import {
  Button,
  Chip,
  colors,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";

import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
  useStylesHed,
  useStylesSpDial,
  useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../Context/InshSt";
import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import { sto } from "../../../../Context/InshData";
import { typeCosts, typeQties } from "../../../../services/safe-grd-services";
import SafesGardTables from "./SafeGrdTable";
import SafesGardForms from "./SafesGardForms";
import deepRenameKeys from "deep-rename-keys";
import { GetItemFromOptions } from "../../../../services/global-services";

const useStyles = makeStyles((theme) => ({
  root: {
    // backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },
  itemW: {
    // display:'flex',
    width: "90%",
  },
  headerTitle: {
    backgroundColor: colors.green[50],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  purchTotalCard: {
    backgroundColor: colors.blue[50],
    borderColor: colors.blue[300],
  },
}));

export default function SafesGard(props) {
  const { AutoOptions, AutoOptionsB } = props;
  const { t } = useTranslation(["forms", "translation"]);

  const SafesEmp = AutoOptionsB?.SafeEmp ? AutoOptionsB?.SafeEmp : AutoOptionsB.Safes;
  const optionsSafeUser = SafesEmp.filter((obj) => obj.branch == sto.branchi);
  const optionsSafesAdmins = AutoOptionsB.Safes.filter((obj) => obj.branch == sto.branchi);
  const [OptionsSafes, setOptionsSafes] = useState(() => {
    return sto.User_typei == 1 ? [{ id: -1, name: t("all"), branch: -1 }, ...optionsSafesAdmins] : [...optionsSafeUser];
  });
  const defBranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches);

  const typePrints = [
    { id: 0, label: "افتراضي", key: "balance" },
    { id: 1, label: "افتراضي2", key: "dept" },
  ];
  const defaultGRDparmsEmp = {
    typeCost: typeCosts[3],
    branch: defBranch,
    safe: optionsSafeUser[0],
    typeQtys: typeQties[3],
    isStore: true,
    isFactory: false,
    isRaw: false,
    typePrint: typePrints[0]
  };
  const [rptParams, setRptParams] = React.useState(defaultGRDparmsEmp);
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();

  const [data, setData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [sum, setSum] = useState(false);
  const viewHandle = async () => {

    setData([]);
    setFetching(true);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSafes/safe-grd?typeCost=${rptParams.typeCost.id}&&safe=${rptParams.safe.id}&&branch=${rptParams.branch.id}
  &&typeQtys=${rptParams.typeQtys.id}&&isStore=${rptParams.isStore}&&isFactory=${rptParams.isFactory}
  &&isRaw=${rptParams.isRaw}`
    } else {
      Urls = `RptSafes/safe-grd?typeCost=${rptParams.typeCost.id}&&safe=${rptParams.safe.id}&&branch=${rptParams.branch.id}
  &&typeQtys=${rptParams.typeQtys.id}&&isStore=${rptParams.isStore}&&isFactory=${rptParams.isFactory}
  &&isRaw=${rptParams.isRaw}&&db_name=${sto.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        setData(
          res.data?.map((itm) => {
            const cost =
              itm?.Cost_Item == null ? itm.Balance != 0
                ? (itm?.sumCost_item / itm.Balance).toFixed(2)
                : 0 : itm?.Cost_Item;
            return {
              ...itm,
              cost: cost,
              sumCost_item: itm?.sumCost_item?.toFixed(2),
            };
          })
        );
        console.log(" the data is", res.data);
        setFetching(false);
      })
      .catch((err) => {
        setFetching(false);
        console.log(err);
        // toast.err("يوجد خطأ في الجلب");
        setData([]);
      });
  };

  const his = useHistory();

  const printHandle = () => {
    const info = {
      columns: columns,
      title: "كشف جرد المخازن",
      data: data,
      kind: rptParams.typePrint.id === 0 ? 1 : 2,
      auto: {
        safe: rptParams.safe.name,
        user: sto.usernames,
        crossTaqeem: rptParams.typeCost.name,
      },
      tot: {
        totSale: data
          ?.reduce((a, v) => (a = a + Number(v.Outcome)), 0)
          ?.toFixed(2),
        totTaqlfa: data
          ?.reduce((a, v) => (a = a + Number(v.sumCost_item)), 0)
          ?.toFixed(2),
        totval: data?.length,
      },
      // nDate: moment(new Date()).format("YYYY-MM-DD"),
      ElmntShow: false,
    };
    //console.log(info)
    localStorage.setItem("iInfos", JSON.stringify(info));
    his.push({ pathname: "/ReviewJard" });
    window.location.reload(false);
  };

  let excel_name = "SafeGardReport";
  var columns = [
    { title: "رقم الباركود", field: "barcode" },
    { title: "الصنف", field: "Name_Item" },
    { title: "الرصيد", field: "Balance" },
    { title: rptParams.typeCost.name, field: "cost" },
    { title: "إجمالي التكلفة", field: "sumCost_item" },
    { title: "إجمالي الوارد", field: "Income" },
    { title: "إجمالي المباع", field: "Outcome" },
  ];
  const excelHeaders = deepRenameKeys(columns, (key) => {
    if (key === "field") return "key";
    if (key === "title") return "label";
  });

  const onChangeData = (propName) => (event) => {
    if (propName == "isStore" || propName === "isRaw" || propName === "isFactory") {
      setRptParams({ ...rptParams, [propName]: event.target.checked });
    } else {
      setRptParams({ ...rptParams, [propName]: event.target.value });
    }
  };
  const onChangeAutoData = (propName, newValue) => {
    if (propName === "branch") {
      const SafesEmp = AutoOptionsB?.SafeEmp ? AutoOptionsB?.SafeEmp : AutoOptionsB.Safes;
      const optinsSafeBranches = SafesEmp.filter((obj) => obj.branch == newValue.id);
      if (optinsSafeBranches !== null) {
        setRptParams({ ...rptParams, [propName]: newValue, safe: optinsSafeBranches[0] });
        setOptionsSafes(sto.User_typei == 1 ? [{ id: -1, name: t("all"), branch: -1 }, ...optinsSafeBranches] : [...optinsSafeBranches]);
      } else {
        const optinsSafeThis = SafesEmp.filter((obj) => obj.branch == sto.branchi);
        setRptParams({ ...rptParams, [propName]: defBranch, safe: optinsSafeThis[0] });
      }
    } else if (propName === "typeCost") {
      setRptParams({ ...rptParams, [propName]: newValue });
      setData([]);
    } else {
      setRptParams({ ...rptParams, [propName]: newValue });
    }
  };
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography
          size="small"
          className={classes.headerTitle}
          color="primary"
        >
          {t("store_inventory_report")}

        </Typography>
      </Grid>
      <Typography
        component="div"
        style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
      >
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor: colors.blue[300],
            borderBottomWidth: "1px",
            borderBottomStyle: "solid",
          }}
        >
          <SafesGardForms
            {...{
              AutoOptions,
              rptParams,
              onChangeData,
              onChangeAutoData,
              typePrints,
              OptionsSafes
            }}
          />
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={
                  (inshst.purch.iconBtn,
                    { borderRadius: 0 })
                }
                className={[clasui.button]}
                onClick={() => viewHandle()}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            <Grid item >
              {data && !fetching && (
                <CSVLink
                  separator={";"}
                  filename={excel_name}
                  data={data}
                  headers={excelHeaders}
                >
                  {" "}
                  <Button
                    disabled={fetching}
                    variant="contained"
                    startIcon={<TableChart />}
                    size="large"
                    color="primary"
                    style={{ borderRadius: 0 }}
                    className={[clasui.button]}
                  >
                    {t("excel_export")}{" "}
                  </Button>
                </CSVLink>
              )}
            </Grid>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={[clasui.button, clasSp.clSec]}
                style={
                  (inshst.purch.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={printHandle}
              >
                {t("forms:print")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={
                  (inshst.purch.iconBtn,
                    { borderRadius: 0 })
                }
                onClick={() => his.goBack()}
              >
                {t("forms:exit")}
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard,
                  title: t("count_row"),
                  value: data?.length,
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard,
                  title: t("total_quantites"),
                  value: !fetching &&
                    data &&
                    data
                      ?.reduce((a, v) => (a = a + Number(v.Balance)), 0)
                      ?.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard,
                  title: t("total_cost"),
                  value: !fetching &&
                    data &&
                    data
                      ?.reduce((a, v) => (a = a + Number(v.sumCost_item)), 0)
                      ?.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalCard
                {...{
                  className: classes.purchTotalCard,
                  title: t("sale_total"),
                  value: !fetching &&
                    data &&
                    data
                      ?.reduce((a, v) => (a = a + Number(v?.Sum_sale_price)), 0)
                      ?.toFixed(2),
                }}
              />
            </Grid>
          </Grid>
        </Container>
        <br />
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
          }}
        >
          <Grid container justifyContent="center">
            <Grid item container justifyContent="center" xs={12}>
              <BeatLoader loading={fetching} color={colors.green[300]} />
              {!fetching && (
                <SafesGardTables
                  {...{
                    data: data ? data : [],
                    rptParams,
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
